import React from 'react';
import {Select} from 'components/Form';
import { useT } from 'hooks/Locale/useT';

interface TestStatusSelectInterface {
    name?: string | string[];
    label?: string;
    layout?: {
        labelCol: {
            span: number
        }
        wrapperCol: {
            span: number
        }
    }
    disabled?: boolean;
    customRules?: any;
    hasDefaultLayout?: boolean;
    type: string;
    isFormItem?: boolean;
    onChange: any;
}

const TestStatusSelect: React.FC<TestStatusSelectInterface> = ({
                                                                     name,
                                                                     label,
                                                                     layout,
                                                                     disabled = false,
                                                                     type,
                                                                     customRules = [],
                                                                     hasDefaultLayout,
                                                                     isFormItem = true,
                                                                     onChange
                                                                 }) => {
    const t = useT();

    const expectedResult = {
        'NOT_STARTED': t('general.not_started'),
        'PASSED': t('general.passed'),
        'NOT_APPLICABLE' : t('lectures.status_NOT_APPLICABLE'),
        'FAILED': t('general.failed'),
    };

    let formItemLayout = layout || {}

    if (hasDefaultLayout) {
        formItemLayout = {
            labelCol: {span: 6},
            wrapperCol: {span: 18}
        }
    }

    return (
        <Select
            customLayout={formItemLayout}
            isFormItem={isFormItem}
            name={name}
            onChange={() => onChange ? onChange(name): null}
            label={label ? t(label): null}
            manualOptions={expectedResult}
            disabled={disabled}
            customRules={customRules}
        />
    )
}
export default TestStatusSelect;
